import Vue from "vue";
import VueRouter from "vue-router";

import App from "./App";
import Offline from "./Offline";
import VerifyPass from "./VerifyPass";

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: "/",
      name: "App",
      component: App
    },
    {
      path: "/manage/customers/:selectNasid",
      name: "customers",
      component: App,
      props: {
        selectSection: "manage",
        selectTab: "customers"
      }
    },
    {
      path: "/grow/report/:selectNasid",
      name: "report",
      component: App,
      props: {
        selectSection: "value",
        selectTab: "report"
      }
    },
    {
      path: "/offline",
      name: "Offline",
      component: Offline
    },
    {
      path: "/auth/verify-pass",
      name: "verify-pass",
      component: VerifyPass
    }
  ]
});
